import {Icon} from "./icon.component";
import {defineWebComponent} from "../webcomponents-utils";

export * from './icon.component';
export default Icon;

defineWebComponent('wl-icon', Icon);